// @flow
import * as React from 'react';
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import {Divider, ListItem} from "@mui/material";
import ListItemText from "@mui/material/ListItemText";
import {admission, info} from "../../helpers/registrationInfo";
import ListItemIcon from "@mui/material/ListItemIcon";
import CircleIcon from '@mui/icons-material/Circle';
import Typography from "@mui/material/Typography";

type Props = {};
const RegistrationInfo = (props: Props) => {
    return (
        <Box sx={{width: '100%', minWidth: '400px', maxWidth: '600px', bgcolor: 'background.paper'}}>
            <Typography
                variant={"h6"}
            >
                INFORMATION REGARDING YOUR REGISTRATION
            </Typography>
            <List>
                {info.map((item, index) => (
                        <ListItem
                            key={index}
                            disablePadding
                            sx={{alignItems: 'baseline', borderBottom: '1px solid #bdbdbd'}}
                        >
                            <ListItemIcon sx={{
                                minWidth: '20px'
                            }}>
                                <CircleIcon
                                    sx={{
                                        fontSize: '10px',
                                        minWidth: '20px'
                                    }}
                                />
                            </ListItemIcon>
                            <ListItemText>
                                <span dangerouslySetInnerHTML={{__html: item}}/>
                            </ListItemText>
                        </ListItem>
                ))}
            </List>
        </Box>
    );
};

export default RegistrationInfo